import type { IMaCriticalData } from '../../types';

export const maCritical = (data: IMaCriticalData) => {
  let text = '';

  const weightIndication = 'weight';
  if (data.templateType) {
    const types = data.templateType.join(', ');
    if (types.length)
      text += `MA reviewed patient’s physiological data. Patient is in critical range ${types}. `;

    // for weight
    const weightTypes = data.weightOptions?.join(', ');
    if (data.templateType?.includes(weightIndication) && weightTypes?.length) {
      text += `Patient uses the scale for ${weightTypes}. `;
    }
  }

  if (data.patientStatus === 'doNotCall') {
    const escalatePerProtocol = data.doNotCallOptions?.includes(
      'escalatePerProtocol',
    );
    if (escalatePerProtocol) {
      text += '\n';
      text +=
        'Patient is Do Not Call status, reading escalated directly to clinic per protocol. ';
    }
  }
  if (data.patientStatus === 'hospitalHold') {
    if (data.hospitalHoldOptions === 'contactedPatient') {
      text += '\n';
      text += 'MA contacted patient. ';

      const wasReadingTrue =
        data.contactedPatientOptions?.includes('wasReadingTrue');
      if (wasReadingTrue) text += 'Patient confirmed reading is theirs. ';

      if (data.removeHospitalHold === 'patientUnableToReCheck')
        text +=
          'Patient unable to recheck at this time, transferred to nurse for assessment. ';
      if (data.removeHospitalHold === 'recheckIsStillCriticalOrAtRisk')
        text +=
          'Recheck is still (critical/at-risk), transferred to nurse for assessment. ';

      const erroneousTxt = 'Reading should be marked as erroneous. ';
      if (data.markAsErroneous === 'someoneElseUsedTheDevice') {
        text += `${erroneousTxt} Someone else used the device. `;
      }
      if (data.markAsErroneous === 'weightAtWrongTimeOfDay') {
        text += `${erroneousTxt} Weight at wrong time of day. `;
      }
      if (data.markAsErroneous === 'incorrectDeviceTechnique') {
        text += `${erroneousTxt} Incorrect device technique. `;
      }
      if (data.markAsErroneous === 'patientReportsReadingIsInError') {
        text += `${erroneousTxt} Patient reports reading is in error. `;
        if (data.patientReportsReadingIsInErrorComment?.trim())
          text += `Erroneous reading is due to ${data.patientReportsReadingIsInErrorComment}. `;
      }
    }

    if (data.hospitalHoldOptions === 'unableToReachPatient') {
      text += '\n';
      text += 'MA unable to reach patient. ';
      const txt = 'according to clinic protocol. ';
      if (data.unableToReachPatientOptions === 'yes')
        text += `Reading escalated ${txt}`;
      if (data.unableToReachPatientOptions === 'no')
        text += `Reading not escalated ${txt}`;
    }
  }

  if (data.hasRecovered === 'yes') {
    text += '\n';
    text += 'Critical reading is recovered to normal. ';
    const txt = 'according to clinic protocol. ';
    if (data.hasRecoveredOptions === 'yes') {
      text += `Reading escalated ${txt}`;
    }
    if (data.hasRecoveredOptions === 'no') {
      text += `Reading not escalated ${txt}`;
    }
  }
  if (data.hasRecovered === 'no') {
    text += '\n';
    text += 'Critical reading is not recovered to normal. ';
  }

  if (data.escalationMethod?.length) {
    const methods = data.escalationMethod.join(', ');
    text += '\n';
    text += `Reading escalated via ${methods}. `;

    if (methods.includes('phone')) {
      if (data.personSpokenTo?.trim())
        text += `MA spoke with ${data.personSpokenTo}. `;
      if (data.summaryOfCall?.trim()) text += `${data.summaryOfCall}. `;
    }
  }

  return text;
};
